<section class="hucu-dialog hucu-dialog--case">
  <header class="hucu-dialog__header">
    <div>
      <p class="hucu-dialog__eyebrow">Gestión de actividades</p>
      <h2>{{ data?.id ? 'Editar' : 'Agregar' }} {{ agregar }}</h2>
      <p>Capture la información y consulte las discusiones relacionadas.</p>
    </div>
    <button type="button" mat-icon-button class="hucu-dialog__close" (click)="onNoClick()"
      aria-label="Cerrar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div mat-dialog-content class="hucu-dialog__content hucu-dialog__content--embedded">
    <div *ngIf="esHistoriaUsuario">
      <app-modal-hu [id_proyecto]="data.id_proyecto" [datosCu]="data.row" [dialogRef]="dialogRef"></app-modal-hu>
    </div>
    <div *ngIf="esEpica">
      <app-modal-epicas [id_proyecto]="data.id_proyecto" [datosCu]="data.row" [dialogRef]="dialogRef"></app-modal-epicas>
    </div>
    <div *ngIf="esCasoDUso">
      <app-modal-cu [id_proyecto]="data.id_proyecto" [datosCu]="data.row" [dialogRef]="dialogRef"></app-modal-cu>
    </div>
    <div *ngIf="esTarea">
      <app-modal-task [id_proyecto]="data.id_proyecto" [datosCu]="data.row" [dialogRef]="dialogRef"></app-modal-task>
    </div>
    <app-dicusiones *ngIf="data && data.id && data.clase" [tipo]="data.clase" [id]="data.id"
      [dialogRef]="dialogRef"></app-dicusiones>
  </div>
</section>
